import React from 'react';
import { useSocket } from '../context/SocketContext';
import './SeatModal.css';

const AVATAR_COLORS = ['#7c3aed','#dc2626','#2563eb','#059669','#d97706','#db2777','#0891b2','#65a30d'];

function avatarColor(name) {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
}

const POS_CLASS = ['s0', 's1', 's2', 's3', 's4', 's5'];

export default function SeatModal({ table, onClose, onJoined }) {
  const { sessions, waitlists, joinSeat, leaveSeat, joinWaitlist, leaveWaitlist } = useSocket();

  const mySession  = sessions[table.id];
  const myWaitlist = waitlists[table.id];
  const takenCount = table.seats.filter(s => s.player).length;
  const isFull     = takenCount === table.max;

  const handleSeatClick = (seatIndex) => {
    if (table.seats[seatIndex].player) return;
    joinSeat(table.id, seatIndex);
    if (onJoined) onJoined(table.id);
    else onClose();
  };

  const handleLeaveSeat = () => {
    leaveSeat(table.id);
    onClose();
  };

  const handleWaitlist = () => {
    if (myWaitlist !== undefined) leaveWaitlist(table.id);
    else                          joinWaitlist(table.id);
  };

  return (
    <div className="seat-overlay" onClick={onClose}>
      <div className="seat-modal" onClick={e => e.stopPropagation()}>

        <div className="seat-modal-header">
          <div className="seat-modal-title-group">
            <h2 className="seat-modal-title">{table.name}</h2>
            <div className="seat-modal-meta">
              <span className={`type-badge ${{ 'No-Limit': 'nl', 'Pot-Limit': 'pl', 'Limit': 'limit', 'Spread-Limit': 'sl' }[table.type] ?? 'pl'}`}>{table.type}</span>
              <span className="seat-modal-stakes">{table.stakes}</span>
            </div>
          </div>
          <button className="seat-modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="seat-layout">
          {table.seats.map((seat, i) => (
            <SeatNode
              key={i}
              seat={seat}
              index={i}
              isMyCurrentSeat={mySession === i}
              onClick={handleSeatClick}
              posClass={POS_CLASS[i]}
            />
          ))}
          <div className="table-felt">
            <span className="felt-name">{table.name}</span>
            <span className="felt-count">{takenCount}/{table.max} seated</span>
          </div>
        </div>

        {mySession !== undefined && (
          <div className="seat-modal-footer">
            <span className="you-are-seated">You're in Seat {mySession + 1}</span>
            <button className="leave-seat-btn" onClick={handleLeaveSeat}>Leave Seat</button>
          </div>
        )}

        {isFull && mySession === undefined && (
          <div className="waitlist-section">
            <span className="waitlist-info">
              {table.waitlist.length > 0
                ? `${table.waitlist.length} player${table.waitlist.length !== 1 ? 's' : ''} waiting`
                : 'Table full — no one waiting yet'}
            </span>
            {myWaitlist !== undefined ? (
              <div className="waitlist-status">
                <span className="waitlist-pos">#{myWaitlist} in queue</span>
                <button className="waitlist-btn leave" onClick={handleWaitlist}>Leave Queue</button>
              </div>
            ) : (
              <button className="waitlist-btn join" onClick={handleWaitlist}>Join Waitlist</button>
            )}
          </div>
        )}

      </div>
    </div>
  );
}

function SeatNode({ seat, index, isMyCurrentSeat, onClick, posClass }) {
  const isOccupied = !!seat.player;

  return (
    <div className={`seat-node ${posClass}`}>
      {isOccupied ? (
        <div
          className={`seat-avatar occupied ${isMyCurrentSeat ? 'mine' : ''} ${seat.player.isBot ? 'is-bot' : ''}`}
          style={!isMyCurrentSeat ? { background: avatarColor(seat.player.name) } : undefined}
        >
          {seat.player.name.charAt(0).toUpperCase()}
        </div>
      ) : (
        <button
          className="seat-avatar empty"
          onClick={() => onClick(index)}
          title={`Take Seat ${index + 1}`}
        >
          +
        </button>
      )}
      <span className="seat-label">
        {isOccupied ? (isMyCurrentSeat ? 'You' : seat.player.name) : `Seat ${index + 1}`}
      </span>
      {isOccupied && seat.player.isBot && !isMyCurrentSeat && (
        <span className="seat-bot-tag">bot</span>
      )}
    </div>
  );
}
